export default "__VITE_ASSET__DP3j41OT__"